var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d2-container-frame',{attrs:{"src":"https://d2-projects.github.io/d2-admin-doc/zh/"}})}
var staticRenderFns = []

export { render, staticRenderFns }